module.exports = __webpack_public_path__ + "media/src/assets/images/about_solution-pic6-9b00edcd3565bd1223f2561e7d67601d.png";